import { render, staticRenderFns } from "./SupervisionToolRevisionItem.vue?vue&type=template&id=15803b39"
import script from "./SupervisionToolRevisionItem.vue?vue&type=script&lang=js"
export * from "./SupervisionToolRevisionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports